module.exports = __webpack_public_path__ + "img/lock.809ed5af.svg";